/* eslint-disable global-require */
import React from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  StyledParagraph,
  StyledH3,
  StyledImage,
  LinkText,
} from "./ReferralStyle";

type HowItWorkCardProps = {
  order: number;
  title: string;
};
const HowItWorkCard = ({ order, title }: HowItWorkCardProps) => {
  const { t } = useTranslation("referral");

  const getImageUrl = (orderNum: number) => {
    switch (orderNum) {
      case 1:
        return `url(${require("assets/referral-lion-background-1.png")})`;
      case 2:
        return `url(${require("assets/referral-lion-background-2.png")})`;
      case 3:
        return `url(${require("assets/referral-lion-background-3.png")})`;
      default:
        return "";
    }
  };

  const getDescription = (orderNum: number) => {
    switch (orderNum) {
      case 1:
        return (
          <>
            {t("Check out our")}
            {` `}
            <LinkText href="https://flexiclasses.com/">{t("website")}</LinkText>
            {` `}
            {t("and this")}
            {` `}
            <LinkText href="https://www.youtube.com/watch?v=QXyXpUnWetY">
              {t("video.")}
            </LinkText>
            {` `}
            {t(
              "Find out why Flexi Classes are revolutionizing how the world studies languages."
            )}
          </>
        );
      case 2:
        return (
          <>
            {t("There are many different plans on offer. ")}
            <LinkText href="https://flexiclasses.com">
              {t("Choose the one")}
            </LinkText>
            {t(" that fits you best and take your first class today.")}
          </>
        );
      case 3:
        return (
          <>
            {t(
              "Register and enter your Discount Code on the payment page. You will receive your 5 free group classes immediately."
            )}
          </>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <StyledImage
        style={{
          backgroundImage: getImageUrl(order), // eslint-disable-line import/no-dynamic-require
        }}
      />
      <Card style={{ height: "200px" }}>
        <StyledH3 style={{ textAlign: "left" }}>{t(title)}</StyledH3>
        <StyledParagraph style={{ textAlign: "left" }}>
          {getDescription(order)}
        </StyledParagraph>
      </Card>
    </>
  );
};

export default HowItWorkCard;
